export const PRICE_INR = 2500;
export const PRICE_LABEL = "₹2,500 · first month";

export const MARKETS = {
  gold: {
    id: "gold",
    name: "50 CR GOLD GLOBAL",
    arena: "Global Gold",
    desc: "XAU/USD & MCX gold — daily bias, levels and live trade sessions in one private room.",
    stat: "XAU/USD · MCX · COMEX",
  },
};

export const MARKET_IDS = Object.keys(MARKETS);

export const PAYMENT_URL = "https://course.onestockacademy.com/payment-page/50cr";

export const inr = (n) => "₹" + Number(n).toLocaleString("en-IN");
